export const capitalizeCityState = (cityState) => {
    if (!cityState)
        return '';
    const cityStateArr = cityState.split(', ');
    return `${cityStateArr[0]
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')}, ${cityStateArr[1]}`;
};
